import { useState } from "react";
import cn from "classnames";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { AscBadgeColor, AscTrackBadgeColor } from "@ascendnow/shared";

import AscAdminAction from "../../AscAdminAction/AscAdminAction";
import { MoreIcon, CalendarEmptyIcon } from "../../AscIcons";
import AscCertificate from "../../AscCertificate/AscCertificate";
import styles from "./AscCertificateCard.module.scss";

dayjs.extend(relativeTime);

type AscCertificateCardSize = "medium" | "large";
export interface AscCertificateCardProps {
  title: string;
  date: string;
  name: string;
  color?: AscBadgeColor | AscTrackBadgeColor;
  earned?: boolean;
  size?: AscCertificateCardSize;
  className?: string;
  loading?: boolean;
  onEdit?: () => void;
  onRemove?: () => void;
}

export default function AscCertificateCard({
  title,
  date,
  name,
  color,
  onEdit,
  onRemove,
  earned,
  className,
}: AscCertificateCardProps) {
  const [showAction, setShowAction] = useState<boolean>(false);

  const handleEdit = () => {
    onEdit && onEdit();
    setShowAction(false);
  };

  const handleRemove = () => {
    onRemove && onRemove();
    setShowAction(false);
  };

  return (
    <div className={cn(styles.ground, className)}>
      <AscCertificate
        color={color}
        className={styles.certificate}
        name={name}
        title={title}
        date={date}
        earned={earned}
      />
      <h5 className={styles.cardTitle}>{title}</h5>
      <div className={styles.cardContent}>
        {onEdit || onRemove || earned ? (
          <>
            <CalendarEmptyIcon className={styles.calendarIcon} />
            <span className={styles.time}>
              {dayjs(date).format("D MMM[,] YYYY")}
            </span>
          </>
        ) : null}

        {onEdit && onRemove && (
          <MoreIcon
            className={styles.icon}
            onClick={() => setShowAction(!showAction)}
          />
        )}
      </div>

      {showAction && (
        <AscAdminAction
          option1={"Edit"}
          option2={"Remove"}
          clickOption1={handleEdit}
          clickOption2={handleRemove}
          className={styles.actionBar}
        />
      )}
    </div>
  );
}
